import React from 'react';
import  { useEffect }from 'react';
import  { useState,   useCallback,
    useMemo,
    useRef,
  
    StrictMode, } from 'react';

import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import Loader3 from './Loader3';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { APICall } from './services/api.service';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import * as actions from './redux/actions'
import { ToastContainer, toast } from 'react-toastify';

import Swal from 'sweetalert2'


import { AgGridReact } from "ag-grid-react";


import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,


    RowSelectionModule,

    ColDef,
    ColGroupDef,
    GridApi,
    GridOptions,
    SizeColumnsToContentStrategy,
    SizeColumnsToFitGridStrategy,
    SizeColumnsToFitProvidedWidthStrategy,
  

  } from "ag-grid-community";
    import { AiOutlineConsoleSql } from 'react-icons/ai';
    import { DiDart } from 'react-icons/di';
    


    import { RowApiModule } from 'ag-grid-community'; 
    import useDebouncedClick from "./useDebouncedClick";


    ModuleRegistry.registerModules([
        RowSelectionModule,
        ClientSideRowModelModule,


        ValidationModule,
        ColumnApiModule,
        ColumnAutoSizeModule,
        RowApiModule
    
    ]);



    const myTheme = themeBalham.withParams({
        headerHeight: "30px",
        headerTextColor: "black",
        headerBackgroundColor: "#99ABCD",
        headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
        headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
        //selectedRowBackgroundColor: 'rgba(0, 255, 0, 0.1)',
        selectedRowBackgroundColor: '#8386a6'
    });
  

    const theme = createTheme({
        palette: {
            primary: {
                main: '#520074'
            }
        },
        mixins: {
            MuiDataGrid: {
            // Pinned columns sections
            pinnedBackground: '#520074',
            // Headers, and top & bottom fixed rows
            containerBackground: 'primary',
            },
        },

    });




function AutoModal(props) {

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const autoSizeStrategy = useMemo(() => {
        return {
        type: "fitGridWidth",
        defaultMinWidth: 100
        };
    }, []);



      const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll();
       
      }, []);

      const selectAll = useCallback((event) =>{

            event.api.selectAll();
      }, []);

      const onColumnResized = useCallback((params) => {
      }, []);

      const themeAG = useMemo(() => {
        return myTheme;
      }, []);



/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */



    const dispatch = useDispatch()


    const navigate = useNavigate();


    const [tableData, setTableData] = useState([])
    const token = localStorage.getItem("token");

    
    const ref = localStorage.getItem("id");

    const username = localStorage.getItem("username");
    const user = localStorage.getItem("user");



    const [open, setOpen] = React.useState(false);


    const isModalOpen = useSelector(state=>state.autoModal ? state.autoModal.open : false)
    
    const [isLoading, setIsLoading] = useState(false)
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false)
    const [message, setMessage] = useState("")

    const [listTkc, setListTkc] = useState();

    const [numInsert, setNumInsert] = useState(0);
    const [numUpdate, setNumUpdate] = useState(0);
    const [numDelete, setNumDelete] = useState(0);

    const [autoTitle, setAutoTitle] = useState('');

    const [tkcArray, setTkcArray] = useState([

        {i_naziv: "Zagreb", i_tkc:"1", i_mreza:'1'},
        {i_naziv: "Krapina", i_tkc:"2", i_mreza:'49'},
        {i_naziv: "Sisak", i_tkc:"3", i_mreza:'44'},
        {i_naziv: "Karlovac", i_tkc:"4", i_mreza:'47'},
        {i_naziv: "Varazdin", i_tkc:"5", i_mreza:'42'},
        {i_naziv: "Koprivnica", i_tkc:"6", i_mreza:'48'},
        {i_naziv: "Bjelovar", i_tkc:"7", i_mreza:'43'},
        {i_naziv: "Rijeka", i_tkc:"8", i_mreza:'51'},
        {i_naziv: "Gospic", i_tkc:"9", i_mreza:'53'},
        {i_naziv: "Virovitica", i_tkc:"10", i_mreza:'33'},
        {i_naziv: "Pozega", i_tkc:"11", i_mreza:'34'},
        {i_naziv: "Slavonski Brod", i_tkc:"12", i_mreza:'35'},
        {i_naziv: "Zadar", i_tkc:"13", i_mreza:'23'},
        {i_naziv: "Osijek", i_tkc:"14", i_mreza:'31'},
        {i_naziv: "Sibenik", i_tkc:"15", i_mreza:'22'},
        {i_naziv: "Vukovar", i_tkc:"16", i_mreza:'32'},
        {i_naziv: "Split", i_tkc:"17", i_mreza:'21'},
        {i_naziv: "Pazin", i_tkc:"18", i_mreza:'52'},
        {i_naziv: "Dubrovnik", i_tkc:"19", i_mreza:'20'},
        {i_naziv: "Cakovec", i_tkc:"20", i_mreza:'40'},
        {i_naziv: "T-Mobile 098", i_tkc:"98", i_mreza:'98'},
        {i_naziv: "T-Mobile 099", i_tkc:"99", i_mreza:'99'},
    ]);



    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };


    useEffect(()=> {
       
        console.log("Auto modal open!!!!");
        getAutoInfo();

    }, [])

    useEffect(()=> {
     
    }, [isModalOpen])



    
    async function automatskoKnjizenje () {

    
        
            dispatch(actions.isLoading());

            let a = 1;


            //***************************************************************** */
            //***************************************************************** */
            //***************************************************************** */
            /*
          
            
            if(props.tkID !=33){
            */
            //***************************************************************** */
            //***************************************************************** */
            //***************************************************************** */
                    for(let i = 0; i<tkcArray.length; i++){
                   

            
                            console.log("Awaiting: " + tkcArray[i].i_tkc);

                            console.log(props.tkID);

                            console.log("Starting round: " + i);

                            let rez = 0;

                            if(props.tkID==33){



                                    //***************************************************************** */
                                    //***************************************************************** */
                                    //***************************************************************** */
                                    console.log("Knjizenje donat");

                                    console.log("Runda: " + i);


                                    rez = await autoKnjizi_Donat (tkcArray[i].i_tkc, tkcArray[i].i_mreza, a);

                                    a=0;
                        
                                    console.log("Awaited: " + tkcArray[i].i_tkc);
                                    console.log("Rezultat: " + rez);





                                    while(rez==10){

                                            console.log("Nije gotovo za i " + i);

                                            rez = await autoKnjizi_Donat (tkcArray[i].i_tkc, tkcArray[i].i_mreza, a);
                                    }
                                    

                                    //***************************************************************** */
                                    //***************************************************************** */
                                    //***************************************************************** */

                            } else {
            
                                    

                                    rez = await autoKnjizi_v2 (tkcArray[i].i_tkc, a);

                                    a=0;


                    
                                    console.log("Awaited: " + tkcArray[i].i_tkc);
                                    console.log("Rezultat: " + rez);

/**************** */
/*
                                    rez = await autoKnjizi_v2 (17, a);
                                    a=0;


                    
                                    console.log("Awaited: " + tkcArray[i].i_tkc);
                                    console.log("Rezultat: " + rez);

                                    rez=1;
                                    i = tkcArray.length-1;
                                    */
/**************** */                                    



                            



                                    while(rez==10){

                                            console.log("Nije gotovo!");

                                            //rez = await autoKnjizi (tkcArray[i].i_tkc);

                                            rez = await autoKnjizi_v2 (tkcArray[i].i_tkc, a);
                                    }

                            }

                            console.log("Done completely with i");

                            console.log("I is: " + i);

                            if(i == (tkcArray.length-1)){

                                    dispatch(actions.isNotLoading());

                                    //toast.success("Uspješno završeno knjiženje podataka", toastSuccess)

                                    Swal.fire({
                                        customClass: {
                                            container: 'my-swal'
                                            },
                                        title: "Uspješno završeno knjiženje podataka",
                                        //showDenyButton: true,
                                        //showCancelButton: true,
                                        confirmButtonText: "OK",
                                        //denyButtonText: `Odustani`
                                        }).then((result) => {
                                            console.log("aaa");
                                        });

                                
                            } else {

                                    console.log("Still needs loading!!!");
                            }
                    }

            //***************************************************************** */
            //***************************************************************** */
            //***************************************************************** */
            /*
            
            } else {


                console.log("***********************************************Obrađujem Donat***********************************************")
            
            
                let tkcArrTmp = [];

                //for(let i = 0; i<tkcArray.length; i++){
                for(let i = 1; i<3; i++){

                    tkcArrTmp.push(tkcArray[i].i_mreza);

                }    

                console.log("Processing the following array: ");
                console.log(tkcArrTmp);

                try {




                            APICall(
                                '/processDonat_v2',
                            
                                {
                                
                                    //tkcArray:tkcArrTmp,
                                    tkcArray: tkcArray
                        
                                }).then((response)=> {
                                        
                                    console.log(response);
                                        dispatch(actions.isNotLoading());

                                        Swal.fire({
                                                customClass: {
                                                    container: 'my-swal'
                                                    },
                                                title: "Uspješno završeno knjiženje podataka",
                                                //showDenyButton: true,
                                                //showCancelButton: true,
                                                confirmButtonText: "OK",
                                                //denyButtonText: `Odustani`
                                                }).then((result) => {
                                                    console.log("aaa");
                                                });         
                                        
                                },
                                (error) => {
                                        console.log("Erroring!!!");
                                        console.log(error);
                                        dispatch(actions.isNotLoading());

                                        Swal.fire({
                                                    customClass: {
                                                        container: 'my-swal'
                                                        },
                                                    title: "Završeno knjiženje podataka - provjerite jer svi podaci nisu uspješno proknjiženi",
                                                    //showDenyButton: true,
                                                    //showCancelButton: true,
                                                    confirmButtonText: "OK",
                                                    //denyButtonText: `Odustani`
                                                    }).then((result) => {
                                                        console.log("aaa");
                                                    });
                                            });                               
                                        

                } catch (err) {
                            console.error("Error calling processing API:", err);

                            dispatch(actions.isNotLoading());

                            Swal.fire({
                                        customClass: {
                                            container: 'my-swal'
                                            },
                                        title: "Završeno knjiženje podataka - provjerite jer svi podaci nisu uspješno proknjiženi",
                                        //showDenyButton: true,
                                        //showCancelButton: true,
                                        confirmButtonText: "OK",
                                        //denyButtonText: `Odustani`
                                        }).then((result) => {
                                            console.log("aaa");
                                        });

                }
                     


            
            
            }
            
            
            */
            //***************************************************************** */
            //***************************************************************** */
            //***************************************************************** */

 
    

    }
    

    
    
    function autoKnjizi_Donat (tkc_id, mreza, a) {



        console.log("AutoKnjizi_Donat Doing the new tkc: ");
        console.log(tkc_id);
        console.log(mreza);

        return new Promise((resolve, reject) => {
  
            APICall(
                '/autoKnjizi_Donat',
              
                {
                
                    tkID:props.tkID,
                    limit:500,
                    tkc: tkc_id,
                    tk_mreza: mreza,
                    ref: ref,
                    first: a
        
                }).then((response)=> {
                        
                        console.log("loading")
                        console.log(response)
                        console.log("no loading");

                        if(!response.data.done){

                            console.log("Nije gotovo!!!!");
                            resolve(10);
                            //resolve(1);

                        } else {
                            console.log("Rez je: ");
                            console.log(response.data.done);

                            resolve (1);

                        }
                        
                },
                (error) => {
                        console.log("Erroring!!!");
                        console.log(error);
    
                        reject(error);
                });    
        });
    

    }
    
//*********************************************** */
//*********************************************** */
//*********************************************** */

    function autoKnjizi_v2 (tkc_id, a) {
        console.log("AutoKnjizi Doing the new tkc: ");
        console.log(tkc_id);
        console.log("Doing operator: " + props.tkID);

        console.log("Referent doing: " + ref);
        console.log(user);
        console.log(username);

        return new Promise((resolve, reject) => {
  
            APICall(
                '/autoKnjizi_v2',
              
                {
                
                    tkID:props.tkID,
                    limit:5000,
                    tkc: tkc_id,
                    ref: ref,
                    first: a
        
                }).then((response)=> {
                        console.log("loading")
                        console.log(response)
                        console.log("no loading");


                        if(!response.data.done){

                            console.log("Nije gotovo!!!!");
                            resolve(10);

                        } else {
                            console.log("Rez je: ");
                            console.log(response.data.done);

                            resolve (1);

                        }
                         
                        
                },
                (error) => {
                        console.log("Erroring!!!");
                        console.log(error);
    
                        reject(error);
                });    
        });
    

    }

//*********************************************** */
//*********************************************** */
//*********************************************** */



    async function getAutoInfo () {
        
      
        console.log("Tuuuuuuu")
        dispatch(actions.isLoading());

        setAutoTitle(props.tkName?props.tkName:'');

        console.log(props.tkID);

        if(props.tkID == 33){

                console.log("Getting the Donat info");

                await APICall("/getAutoInfoDonat",{
                    
                        platform: '0',
                        version:'1.0',
                        tableName: props.tableName,
                        tkID:props.tkID,

        
                },{
                    token
                }).then(response=> {
                    console.log(response)

                    dispatch(actions.isNotLoading());
                    
                    if(response.status==200) {
        
                            var dataTmp = response.data;

            
                            let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                            var a = column.charAt(0).toUpperCase() + column.slice(1)

                                if(column=="koliko_uk"){
                                    return(
                                        {
                                            "field": "koliko_uk",
                                            "headerName":"Uključenja",
                                            "getRowId": index
                                        }
                                    )
                                } else if(column=="koliko"){
                                    return(
                                        {
                                            "field": "koliko",
                                            "headerName":"Ukupno",
                                            "getRowId": index
                                        }
                                    )
                                } else if(column=="koliko_isk"){
                                    return(
                                        {
                                            "field": "koliko_isk",
                                            "headerName":"Isključenja",
                                            "getRowId": index
                                        }
                                    )
                                } else if(column=="koliko_prom"){
                                    return(
                                        {
                                            "field": "koliko_prom",
                                            "headerName": "Promjena",
                                            "getRowId": index
                                        }
                                    )
                                } else {
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index
                                    }
                                )
                                }
                            })
                            let rows =dataTmp.list.map((item, index)=> {
                                return({...item,id:index})
                            })
            
                            console.log({
                                columns,
                                rows
                            })
                            setTableData({
                                columns,
                                rows
                            })

                    } else {


                            if(response.status == 401){
            
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());

                                    navigate('/');
            
                            } else{
            
                                    toast.error(response.data.message, toastError);
            
            
                            }
                    
      


                    } 
        
        
                }).catch((error) => {
                
                                dispatch(actions.isNotLoading());
                
                            
                            
                
                
                            
                                        if(!error.response){
                
                                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                  toastError);
                                          
                
                
                                        } else {
                
                
                                             if(!error.response.status){
                
                                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                  toastError);
                
                                             }else{
                
                                                  if (error.response.status == 401) {
                              
                                           
                                                       toast.error("Istekla je korisnička sesija, molimo ponovite prijavu na uslugu",
                                                            toastError);
                                                    
                                                            setTimeout(() => {
                                                                dispatch(actions.logOut());
                                                                navigate('/');
                                                            }, 5000);   
                
                                                  
                                             
                                                  } else {
                                             
                                             
                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                 toastError);
                                                                                           
                                                       
                                                  }
                                             }
                                        }
                                    
                                   
                            
                            
                });

        } else {

                console.log("Getting the other info");

                await APICall("/getAutoInfo",{
                    platform: '0',
                    version:'1.0',
                    tableName: props.tableName,
                    tkID:props.tkID,
                   


                },{
                    token
                }).then(response=> {
                    console.log(response)

                    dispatch(actions.isNotLoading());
                    
                    if(response.status==200) {
        
                            var dataTmp = response.data;

            
                            let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                            var a = column.charAt(0).toUpperCase() + column.slice(1)


                            if(column=="koliko_uk"){
                                return(
                                    {
                                        "field": "koliko_uk",
                                        "headerName": "Uključenja",
                                        "getRowId": index
                                    }
                                )
                            } else if(column=="koliko"){
                                return(
                                    {
                                        "field": "koliko",
                                        "headerName": "Ukupno",
                                        "getRowId": index
                                    }
                                )
                            } else if(column=="koliko_isk"){
                                return(
                                    {
                                        "field": "koliko_isk",
                                        "headerName": "Isključenja",
                                        "getRowId": index
                                    }
                                )
                            } else if(column=="koliko_prom"){
                                return(
                                    {
                                        "field": "koliko_prom",
                                        "headerName": "Promjene",
                                        "getRowId": index
                                    }
                                )
                            } else {
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index
                                    }
                                )
                            }                            

                            })
                            let rows =dataTmp.list.map((item, index)=> {
                                return({...item,id:index})
                            })
            
                            console.log({
                                columns,
                                rows
                            })
                            setTableData({
                                columns,
                                rows
                            })

                    } else {


                            if(response.status == 401){
            
                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());

                                    navigate('/');
            
                            } else{
            
                                    toast.error(response.data.message, toastError);
            
            
                            }
                    
      


                    } 
        
        
                }).catch((error) => {
                
                                dispatch(actions.isNotLoading());
                
                            
                            
                
                
                            
                                        if(!error.response){
                
                                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                  toastError);
                                          
                
                
                                        } else {
                
                
                                             if(!error.response.status){
                
                                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                  toastError);
                
                                             }else{
                
                                                  if (error.response.status == 401) {
                              
                                           
                                                       toast.error("Istekla je korisnička sesija, molimo ponovite prijavu na uslugu",
                                                            toastError);
                                                    
                                                            setTimeout(() => {
                                                                dispatch(actions.logOut());
                                                                navigate('/');
                                                            }, 5000);   
                
                                                  
                                             
                                                  } else {
                                             
                                             
                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                 toastError);
                                                                                           
                                                       
                                                  }
                                             }
                                        }
                                    
                                   
                            
                            
                });
    }
}
        

    return (
    <>


            <Modal
             open={isModalOpen}
            onClose={()=>{

         
                dispatch(actions.closeAutoModal())
                
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            > 
                  <Box sx={style}>
                    <div className="loader-container loader-container-automodal" style={{visibility:isLoading ? "visible" : "hidden"}}>
                        <Loader3 />
                    </div>
                    <Box className="auto-modal-title">
                        <Typography variant={"h5"}>
                            {autoTitle}
                        </Typography>
                    </Box>

                    <div className="auto-modal-data-display-table">

                        {/*{tableData.rows 
                        && <DataGrid  sx={{ height: 500 }}
                      
                        rowHeight={25}
                        rows={tableData.rows}
                        columns={tableData.columns}
                            disableRowSelectionOnClick
                            
                        />
                        
                        } */}

                        {tableData.rows && <div style={{ width: "100%", height: "100%" }}>

                        <AgGridReact
                                rowData={tableData.rows}
                                columnDefs={tableData.columns}


                                ref={gridRef}
                                theme={themeAG}
                              
                                autoSizeStrategy={autoSizeStrategy}
                                onGridReady={onGridReady}
                                onColumnResized={onColumnResized}


                        /></div>

                        }
                            
                        </div>

                    <div className="auto-modal-data-display-action">
                        <div className="auto-modal-auto-button">
                                        <Button
                                            fullWidth
                                            variant="contained"
                                        
                                            onClick={() => {
                                                    dispatch(actions.closeAutoModal())
                                                    
                                                    automatskoKnjizenje();

                                
                                            }}
                                    
                                            >
                                            Auto
                                        </Button>

                        </div>
                        <div className="auto-modal-auto-button ">
                                            <Button
                                            className='button button-green'
                                                fullWidth
                                                variant="contained"
                                                onClick={() => {
                                                    dispatch(actions.closeAutoModal())
                                                }}
                                                >
                                                Izađi
                                            </Button>

                        </div>

                    </div>
                  </Box>

            </Modal>
            <Modal
             open={isSecondModalOpen}
             onClose={()=>{

         
                setIsSecondModalOpen(false)
                
            }}
             >
                <Box sx={style}>
                    <div className="loader-container loader-container-automodal" style={{visibility:isLoading ? "visible" : "hidden"}}>
                        <Loader3 />
                        </div>
                        <div>
                            {message}
                        </div>
                        <div className="auto-modal-data-display-action">
                        <div className="auto-modal-auto-button">
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            onClick={() => {
                                                dispatch(actions.closeAutoModal())
                                                setIsSecondModalOpen(false);
                                            }}
                                    
                                            >
                                            Auto
                                        </Button>

                        </div>
                        <div className="auto-modal-auto-button ">
                                            <Button
                                            className='button button-green'
                                                fullWidth
                                                variant="contained"
                                                onClick={() => {
                                                    dispatch(actions.closeAutoModal())
                                                    setIsSecondModalOpen(false)
                                                }}
                                                >
                                                Izadi
                                            </Button>

                        </div>

                    </div>
                </Box>

            </Modal>
    </>
    )
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    padding: "32px 32px 0 32px",
    zIndex:20000,
    resize:'both',
    overflow:'auto',
    height: '90%',
  };
  
export default AutoModal